/**
 * Données démo ceintures / progression / examens — Phase 1 local.
 * Exigences et résultats non officiels — clairement [DÉMO].
 */

import {
  SEED_STUDENT_DEMO_CHILD_ID,
  SEED_STUDENT_MARCEL_ID,
  SEED_STUDENT_NATALIE_ID,
} from "./phase1InitialSeed046.js";

/** @type {import('./types.js').CeintureGrade[]} */
export const demoCeintures = [
  {
    id: "belt-white",
    nom: "[DÉMO] Blanche",
    couleur: "blanche",
    ordre: 1,
    niveau: "10e kyu",
    style: "Shotokan",
    exigences: "Positions de base, salutations — référentiel démo à valider.",
    statut: "actif",
    demo: true,
  },
  {
    id: "belt-yellow",
    nom: "[DÉMO] Jaune",
    couleur: "jaune",
    ordre: 2,
    niveau: "9e kyu",
    style: "Shotokan",
    exigences: "Kata Taikyoku Shodan (démo), techniques de base.",
    statut: "actif",
    demo: true,
  },
  {
    id: "belt-orange",
    nom: "[DÉMO] Orange",
    couleur: "orange",
    ordre: 3,
    niveau: "8e kyu",
    style: "Shotokan",
    exigences: "Enchaînements, kumite léger — démo.",
    statut: "actif",
    demo: true,
  },
  {
    id: "belt-green",
    nom: "[DÉMO] Verte",
    couleur: "verte",
    ordre: 4,
    niveau: "7e kyu",
    style: "Shotokan",
    exigences: "Katas Heian — extrait démo.",
    statut: "a_valider",
    demo: true,
  },
  {
    id: "belt-blue",
    nom: "[DÉMO] Bleue",
    couleur: "bleue",
    ordre: 5,
    niveau: "6e kyu",
    style: "Shotokan",
    exigences: "Techniques intermédiaires — à valider officiellement.",
    statut: "a_valider",
    demo: true,
  },
  {
    id: "belt-brown",
    nom: "[DÉMO] Brune",
    couleur: "brune",
    ordre: 6,
    niveau: "3e kyu",
    style: "Shotokan",
    exigences: "Katas avancés — démo Phase 2.",
    statut: "futur",
    demo: true,
  },
  {
    id: "belt-black",
    nom: "[DÉMO] Noire",
    couleur: "noire",
    ordre: 7,
    niveau: "1er dan",
    style: "Shotokan",
    exigences: "Grade dan — hors Phase 1 opérationnelle.",
    statut: "futur",
    demo: true,
  },
];

/** Critères par défaut pour nouvelle progression */
export function defaultCriteres() {
  const now = new Date().toISOString().slice(0, 10);
  return {
    techniques: { statut: "non_commence", note: "", updatedAt: now },
    kata: { statut: "non_commence", note: "", updatedAt: now },
    kumite: { statut: "non_commence", note: "", updatedAt: now },
    discipline: { statut: "non_commence", note: "", updatedAt: now },
    presence: { statut: "non_commence", note: "", updatedAt: now },
    examen: { statut: "non_commence", note: "", updatedAt: now },
  };
}

/** @type {import('./types.js').StudentProgression[]} */
export const demoProgressions = [
  {
    id: "prog-seed-marcel",
    student_id: SEED_STUDENT_MARCEL_ID,
    ceinture_actuelle_id: "belt-white",
    prochaine_ceinture_id: "belt-yellow",
    pourcentage_progression: 12,
    statut: "en_progression",
    recommandation_examen: false,
    notes_sensei: "",
    notes_sempai: "",
    criteres: defaultCriteres(),
    demo: false,
  },
  {
    id: "prog-seed-natalie",
    student_id: SEED_STUDENT_NATALIE_ID,
    ceinture_actuelle_id: "belt-white",
    prochaine_ceinture_id: "belt-yellow",
    pourcentage_progression: 8,
    statut: "en_progression",
    recommandation_examen: false,
    notes_sensei: "",
    notes_sempai: "",
    criteres: defaultCriteres(),
    demo: false,
  },
  {
    id: "prog-seed-demo-enfant",
    student_id: SEED_STUDENT_DEMO_CHILD_ID,
    ceinture_actuelle_id: "belt-white",
    prochaine_ceinture_id: "belt-yellow",
    pourcentage_progression: 48,
    statut: "en_progression",
    recommandation_examen: false,
    notes_sensei: "[DÉMO] Assiduité correcte — continuer kata Taikyoku.",
    notes_sempai: "",
    criteres: {
      techniques: { statut: "en_cours", note: "Positions de base OK", updatedAt: "2026-06-10" },
      kata: { statut: "a_pratiquer", note: "Taikyoku Shodan en cours", updatedAt: "2026-06-15" },
      kumite: { statut: "non_commence", note: "", updatedAt: "2026-06-01" },
      discipline: { statut: "maitrise", note: "Respect du dojo", updatedAt: "2026-06-20" },
      presence: { statut: "en_cours", note: "Présences légères consultées", updatedAt: "2026-06-30" },
      examen: { statut: "non_commence", note: "", updatedAt: "2026-06-01" },
    },
    demo: true,
  },
];

/** @type {import('./types.js').LightExamen[]} */
export const demoExamens = [
  {
    id: "exam-demo-01",
    titre: "[DÉMO] Examen passage ceinture jaune",
    event_id: "demo-event-05",
    dojo_id: "demo-dojo-01",
    date: "2026-12-01",
    grade_vise_id: "belt-yellow",
    etudiants_inscrits: [SEED_STUDENT_MARCEL_ID],
    statut: "inscriptions_ouvertes",
    responsable_id: "demo-sensei-placeholder",
    notes: "Examen léger Phase 1 — aucune certification officielle.",
    demo: true,
  },
  {
    id: "exam-demo-02",
    titre: "[DÉMO] Session examens intermédiaires",
    event_id: null,
    dojo_id: "demo-dojo-01",
    date: "2027-03-01",
    grade_vise_id: "belt-orange",
    etudiants_inscrits: [SEED_STUDENT_NATALIE_ID],
    statut: "planifie",
    responsable_id: "demo-sensei-placeholder",
    notes: "Planification démo — fichier officiel en attente.",
    demo: true,
  },
  {
    id: "exam-demo-futur",
    titre: "[DÉMO] Examens ceintures — futur",
    event_id: "demo-event-05",
    dojo_id: "demo-dojo-01",
    date: "2027-06-01",
    grade_vise_id: "belt-green",
    etudiants_inscrits: [],
    statut: "futur",
    responsable_id: "demo-sensei-placeholder",
    notes: "Module complet Phase 2+.",
    demo: true,
  },
];
